// Scroll infinito para grids de producto (colecciones, búsqueda y Search & Discovery).
// Progresivo: si falla o no hay JS, la paginación clásica sigue funcionando normalmente.
(() => {
  if (window.StriveInfiniteScrollReady) return;
  window.StriveInfiniteScrollReady = true;

  const NEXT_LINK_SELECTOR = '.pagination-wrapper a.pagination__item--prev[href]';
  const GRID_SELECTOR = '#ProductGridContainer ul.grid, #ProductGridContainer .product-grid ul.grid';
  const ROOT_MARGIN = '150px 0px';

  const getSectionId = (container) => {
    const el = container.querySelector('[data-id]');
    return el ? el.dataset.id : null;
  };

  const ensureStatus = (container) => {
    let status = container.querySelector('[data-strive-infinite-status]');
    if (!status) {
      status = document.createElement('div');
      status.setAttribute('data-strive-infinite-status', '');
      status.className = 'strive-infinite-status';
      status.setAttribute('aria-live', 'polite');
      container.appendChild(status);
    }
    return status;
  };

  const setLoading = (container, isLoading) => {
    const status = ensureStatus(container);
    status.classList.toggle('is-loading', isLoading);
    status.textContent = isLoading ? 'Cargando más productos…' : '';
  };

  class InfiniteController {
    constructor(container) {
      this.container = container;
      this.observer = null;
      this.loading = false;
      this.attach();
    }

    attach() {
      if (this.observer) this.observer.disconnect();
      const nextLink = this.container.querySelector(NEXT_LINK_SELECTOR);
      const status = ensureStatus(this.container);
      if (!nextLink) {
        status.textContent = '';
        return;
      }
      // Ojo: el link "siguiente" vive dentro de .pagination-wrapper, que se oculta por CSS
      // (display: none). Un elemento oculto nunca "intersecta" nada, así que el sensor real
      // es el último producto cargado, no el link en sí.
      const grid = this.container.querySelector(GRID_SELECTOR);
      const sentinel = grid ? grid.lastElementChild : null;
      if (!sentinel) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
        },
        { rootMargin: ROOT_MARGIN }
      );
      this.observer.observe(sentinel);
    }

    loadNext() {
      if (this.loading) return;
      const nextLink = this.container.querySelector(NEXT_LINK_SELECTOR);
      if (!nextLink) return;
      const sectionId = getSectionId(this.container);
      if (!sectionId) return;

      this.loading = true;
      setLoading(this.container, true);
      if (this.observer) this.observer.disconnect();

      const nextUrl = new URL(nextLink.href, window.location.origin);
      nextUrl.searchParams.set('section_id', sectionId);

      fetch(nextUrl.toString())
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = doc.querySelector(GRID_SELECTOR);
          const currentGrid = this.container.querySelector(GRID_SELECTOR);
          const oldWrapper = this.container.querySelector('.pagination-wrapper');
          const newWrapper = doc.querySelector('.pagination-wrapper');

          if (newGrid && currentGrid) {
            currentGrid.append(...newGrid.children);
          }
          if (oldWrapper) oldWrapper.remove();
          if (newWrapper) {
            newWrapper.querySelectorAll('.scroll-trigger').forEach((el) => el.classList.add('scroll-trigger--cancel'));
            this.container.appendChild(newWrapper);
          }
          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(this.container);
          }
        })
        .catch(() => {
          // Si algo falla, el link "Siguiente" clásico sigue en el DOM y funciona igual.
        })
        .finally(() => {
          this.loading = false;
          setLoading(this.container, false);
          this.attach();
        });
    }
  }

  // container -> referencia al <ul class="grid"> que tiene actualmente un controlador activo.
  const gridOfContainer = new WeakMap();

  const init = (container) => {
    const grid = container.querySelector(GRID_SELECTOR);
    if (!grid) return;
    // Un filtro reemplaza TODO #ProductGridContainer.innerHTML (facets.js), así que el <ul>
    // cambia de identidad. Nuestro propio loadNext() solo AGREGA hijos al <ul> existente y
    // reinserta el bloque de paginación como hijo directo del contenedor — eso también dispara
    // el MutationObserver de abajo, pero el <ul> sigue siendo el mismo nodo, así que lo ignoramos.
    if (gridOfContainer.get(container) === grid) return;
    gridOfContainer.set(container, grid);
    new InfiniteController(container);
  };

  const scan = () => {
    document.querySelectorAll('#ProductGridContainer').forEach((container) => {
      if (!container.isConnected) return;
      init(container);
    });
  };

  scan();

  document.querySelectorAll('#ProductGridContainer').forEach((container) => {
    const mo = new MutationObserver(() => init(container));
    mo.observe(container, { childList: true });
  });
})();
